import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { debounce } from "lodash";
import queryString from "query-string";

import { withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../general/Loader";
import { apiUrl } from "../../utils/apiUrl";
import { auth } from "../../utils/auth";
import { toast } from "../../utils/helpers";

class Contactos extends Component {
    state = {
        activo: {},
        contactos: [],
        contacto: {},
        links: null,
        loading: true,
        showCreate: false,
        showEdit: false,
        showSidePopup: false,
    };
    constructor(props) {
        super(props);
        this.sidePopupWrap = React.createRef();
        this.sidePopupOverlay = React.createRef();
    }
    componentDidMount() {
        this.getContactos();
        const params = queryString.parse(window.location.search);
        if (params.id !== undefined) {
            this.onFiltroChange(params.id, "buscar");
            this.setState({
                activo: params.id,
            });
        }
    }
    getContactos = async (url = null) => {
        url = url ? url + "&limit=20" : "contactos?limit=20";
        const contactos = await this.props.request(url);

        if (contactos.data) {
            this.setState({
                contactos: contactos.data,
                links: contactos.links,
                meta: contactos.meta,
                loading: false,
            });
        }
    };
    onFiltroChange = debounce(async (value, filtro) => {
        await this.setState({
            filtros: {
                ...this.state.filtros,
                [filtro]: value,
            },
        });

        let query = Object.keys(this.state.filtros).map((fil) => {
            return `${fil}=${this.state.filtros[fil]}`;
        });

        this.getContactos("contactos?limit=20&" + query.join("&"));
    }, 500);
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            contacto: {},
        });
    };
    toggleEditModal = (contacto) => {
        this.setState({
            showEdit: !this.state.showEdit,
            contacto: contacto,
        });
    };
    changeItem = (activo) => {
        this.setState({
            activo,
        });
        this.toggleSidePopup(true);
    };
    toggleSidePopup = (show) => {
        if (!show) {
            this.sidePopupWrap.current.classList.remove("slideInRight");
            this.sidePopupWrap.current.classList.add("slideOutRight");
            this.sidePopupOverlay.current.classList.remove("fadeIn");
            this.sidePopupOverlay.current.classList.add("fadeOut");
            setTimeout(() => {
                this.setState({
                    showSidePopup: show,
                });
            }, 1000);
            return;
        }

        this.setState({
            showSidePopup: true,
        });
    };
    deleteContacto = async (event, contacto) => {
        event.preventDefault();

        this.toggleSidePopup(false);

        const token = auth.getToken();

        const url = `contactos/${contacto}`;

        const res = await fetch(apiUrl(url), {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.getContactos();
            toast("Contacto borrado.");
            return;
        } else {
            toast(response.data, "error");
        }
    };
    render() {
        const { contactos, showSidePopup, activo, loading } = this.state;

        const itemActivo = contactos.filter(
            (contacto) => contacto.id === activo
        )[0];

        return (
            <div>
                <div className='page-header'>
                    <h1 className='page-title row'>
                        <span className='col'>Contactos</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Contacto
                        </button>
                    </h1>
                </div>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col-md-8'>
                                <label>Buscar</label>
                                <input
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "buscar"
                                        )
                                    }
                                    type='search'
                                    placeholder='Buscar...'
                                    className='form-control'
                                    name='buscar'
                                />
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor='estado'>Tipo</label>
                                <select
                                    className='form-control'
                                    name='tipo'
                                    id='tipo'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "tipo"
                                        )
                                    }>
                                    <option value='todos'>Todos</option>
                                    <option value='Suplidor'>Suplidores</option>
                                    <option value='Cliente'>Clientes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!contactos.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            Todavía no hay contactos creados.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Tipo</th>
                                                <th>Telefono</th>
                                                <th>Celular</th>
                                                <th>Email</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactos.map((contacto) => (
                                                <tr
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.changeItem(
                                                            contacto.id
                                                        );
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    className='tr-shadow'
                                                    key={contacto.id}>
                                                    <td>{contacto.nombre}</td>
                                                    <td>{contacto.tipo}</td>
                                                    <td>{contacto.telefono}</td>
                                                    <td>{contacto.celular}</td>
                                                    <td>{contacto.email}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getContactos}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {showSidePopup && (
                    <div className='side-popup'>
                        <div
                            onClick={() => this.toggleSidePopup(false)}
                            ref={this.sidePopupOverlay}
                            className='side-popup-background animated fadeIn'></div>
                        <div
                            ref={this.sidePopupWrap}
                            className='side-popup-container animated slideInRight fast'>
                            <h2>
                                {itemActivo.nombre}{" "}
                                <button
                                    className='btn btn-primary float-right contacto'
                                    data-toggle='tooltip'
                                    data-placement='top'
                                    title=''
                                    data-original-title='Edit'
                                    onClick={() => {
                                        this.toggleEditModal(itemActivo);
                                    }}>
                                    <i className='zmdi zmdi-edit' />
                                </button>
                            </h2>
                            <br />
                            <table className='table'>
                                <tbody>
                                    <tr>
                                        <td>Encargado</td>
                                        <td>{itemActivo.encargado}</td>
                                    </tr>
                                    <tr>
                                        <td>Tipo</td>
                                        <td>{itemActivo.tipo}</td>
                                    </tr>
                                    <tr>
                                        <td>Teléfono</td>
                                        <td>{itemActivo.telefono}</td>
                                    </tr>
                                    <tr>
                                        <td>Celular</td>
                                        <td>{itemActivo.celular}</td>
                                    </tr>
                                    <tr>
                                        <td>Cédula/RNC</td>
                                        <td>{itemActivo.rnc}</td>
                                    </tr>
                                    <tr>
                                        <td>Dirección</td>
                                        <td>{itemActivo.direccion}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <form
                                onSubmit={(e) =>
                                    this.deleteContacto(e, itemActivo.id)
                                }>
                                <p className='text-right'>
                                    <button
                                        type='submit'
                                        className='btn btn-danger btn-sm'>
                                        <i className='fa fa-trash-alt'></i>
                                    </button>
                                </p>
                            </form>
                        </div>
                    </div>
                )}
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        contacto={this.state.contacto}
                        getContactos={this.getContactos}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        contacto={this.state.contacto}
                        getContactos={this.getContactos}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(Contactos));
